import { createSlice } from '@reduxjs/toolkit';
import { stat } from 'fs';
import { PageLink } from '../../_metronic/layout/core/PageData'
import { GetPageTitleData, SetPageTitleData } from './PageTitleOperation'
import { PageDataState } from './index'
import BreadCrumpOperation from '../../app/pages/components/BreadCrumpOperation';

const initialState: PageDataState = {
    PageLinkList: []
}



const pageLinkSlice = createSlice({
    name: 'pageLinks',
    initialState,
    reducers: {
        appendPageLink(state, action: { payload: PageLink }) {
            state.PageLinkList?.push(action.payload);
        },
        removePageLink(state, action: { payload: string }) {
            var items = state.PageLinkList?.filter(x => x.title != action.payload);
            state.PageLinkList = items;
        },
        deletePageLinks(state, action: { payload: [] }) {
            state.PageLinkList = [];
        }
    }
});

export const {
    appendPageLink,
    deletePageLinks,
    removePageLink
} = pageLinkSlice.actions;

export default pageLinkSlice.reducer; 